import { all, takeLatest } from 'redux-saga/effects';
import { fetchKarmaEarnList } from '../actions';
import fetchKarmaEarnListWorker from './worker.fetchKarmaEarnList';

function* karmaEarnSaga() {
  yield all([takeLatest(fetchKarmaEarnList, fetchKarmaEarnListWorker)]);
}

export default karmaEarnSaga;
